import AssignUnassignButton from "./AssignUnassignButton";
import { isDriverReadyForDispatch } from "../../../utils";
import React from "react";
import { isDriverGridAssignmentDisabled } from "../../../utils/pickupAssignmentRules";
import { DRIVER_GRID_COMMANDS } from "../constants";

class ActionButtonRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      command: this.getCommand(props),
      disabled: this.getDisableStatus(props, this.getCommand(props)),
    };
  }

  refresh = (props) => {
    this.setState({
      command: this.getCommand(props),
      disabled: this.getDisableStatus(props, this.getCommand(props)),
    });
    return true;
  };

  getCommand = (props) => {
    const selectedPickupRoutes = [
      ...new Set(
        props.api.selectedVisiblePickupsInGrid?.map((pickup) => pickup.driverId?.toUpperCase())
      ),
    ].filter(Boolean);
    
     // get unique list of drivers for selected pickups
    if (!Boolean(props.data?.dispatchId)) { //Ignore the pickup selection if the driver has not yet been dispatched.
      return DRIVER_GRID_COMMANDS.DISPATCH;
    } else if(
      selectedPickupRoutes.length === 1 &&
      selectedPickupRoutes.includes(props.data?.driverId?.toUpperCase())
    ) {
      // If selected pickup belong same driver show unassign
      return DRIVER_GRID_COMMANDS.UNASSIGN;
    } else if (selectedPickupRoutes.filter(Boolean).length === 0) {
      // if none of the selected pickup have drivers show Assign
      return DRIVER_GRID_COMMANDS.ASSIGN;
    } else {
      return DRIVER_GRID_COMMANDS.REASSIGN;
    }
  };

  shouldComponentUpdate(_nextProps, nextState) {
    return (
      this.state.command !== nextState.command ||
      this.state.disabled !== nextState.disabled
    );
  }

  getDisableStatus = (props, command) => {
    const enableDispatchDriver = props.context.enableDispatchDriver;

    return command === DRIVER_GRID_COMMANDS.DISPATCH
      ? !enableDispatchDriver &&
          !isDriverReadyForDispatch({
            driverClockedInTime: props.data.driverClockedInTime,
            isCompanyDriver: props.data.isCompanyDriver,
            terminalOffset: props.context.terminalOffset
          })
      : isDriverGridAssignmentDisabled({
          selectedPickups: props.api.selectedVisiblePickupsInGrid,
          command,
          terminalOffset: props.context.terminalOffset,
        });
  };

  render() {
    const { command, disabled } = this.state;
    return (
      <div>
        <AssignUnassignButton
          variant="outlined"
          color="primary"
          disabled={disabled}
          onClick={() =>
            this.props.api.runCommand(command, {
              driver: this.props.node.data
            })
          }
          data-automationid={command}
        >
          {command}
        </AssignUnassignButton>
      </div>
    );
  }
}

export default ActionButtonRenderer;
